module.exports = __webpack_public_path__ + "img/it_book.a787d71b.png";